import { SectionCard } from "../../../components/card";
import { Stepper, StepperItem } from "../../../components/stepper";
import { stepperItemsStageD } from "../../../utils/shared-dropdown";
import ApplicationCooLayout from "../../../layout/application-coo-layout";
import { TextSubheader } from "../../../components/text/text-subheader";
import { P2Button, P2ButtonGroup, P2TextDescription, P2Modal } from "react-bootstrap-common-script";
import { Separator } from "../../../components/separator";
import DownloadFinancialPlan from "./download-financial-plan";
import { useInitialWindowScrollTo } from "../../../hooks/use-initial-window-scroll-to";
import { useAppSelector } from "../../../redux/hook";
import { useGetStageD1ObjQuery } from "../../../redux/services/getStageD";
import { useMemo, useCallback, useEffect, useState } from "react";
import ReviewingPage from "../step-1/reviewing-page";
import { LottieLoader } from "../../../components/loader";
import { useNavigate } from "react-router-dom";
import { API_ApplicationReply, API_ApplicationStageUpdate, API_SolicitorUpdate } from "../../../utils/api";
import { PolymerAxios } from "../../../utils/axios";
import { StructureStatusEnum } from "../../../models/enum/structure-status.enum";
import { stageDTrackingId } from "../../../utils/wogaa-ids";
import { customWindow } from "../../../models/interfaces/wogaa.interface";
import {   
  StageDDocumentsInfo,
  StageDMessageInfo,
  StageDMessageType,
  StageDReviewApplication,
  StageDSolicitorApplication,
  StageDSolicitorApplicationForm,
  StageDSolicitorUpdate } from "../../../models/classes/stage-d/Review-Application.class";
import { IErrors, useForm } from "../../../hooks/use-form";
import { v4 as uuidv4 } from 'uuid';
import ApplicationUpdateForm from "../step-1/application-update-form";
import { FileItem } from "../../../models/polymer/Document.model";
import { validateStageDSolicitor } from "../../../utils/validators/stage-d/solicitor-validator";
import { cloneDeep, uniq } from "lodash";

let activeStep = 3;

interface FieldValidationInterface {
  isValid: boolean;
  isPartial: boolean;
}
function StageDFinancialReview() {

  const navigate = useNavigate();
  const [requiredReply, setRequiredReply] = useState<boolean>(false);
  const [filesItemsStorage, setFileItemsStorage] = useState<FileItem[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pendingItems, setPendingItems] = useState<string[]>([]);
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  
  useInitialWindowScrollTo();
  const loginUser = useAppSelector(state => state.auth.AuthenticationSlice.loginUser);
  const applicationStep1FormData = useAppSelector(state => state.app.ApplicationStep1Slice.formData);
  const startApplicationFormData = useAppSelector((state) => state.app.ApplicationStartSlice.formData);

  const queryParameters = new URLSearchParams(window.location.search)
  // const application_uuid = queryParameters.get("application_id");
  const application_uuid = useAppSelector(state => state.app.ApplicationIdSlice.applicationId);
  const singpassToken = useAppSelector(state => state.auth.AuthenticationSlice.singpassToken);
  
  const { values: applicationInPrincipleValue, setFormValue: applicationReviewSetFormValue }: { handleChange: any; values: StageDReviewApplication; errors: IErrors; formValid: boolean; setFormValue: (update: any) => void; } = useForm( new StageDReviewApplication(), () => {}, () => {});

  const loginUserStructureStatus = useMemo(()=>{
    const structure_status = applicationStep1FormData?.household.incoming_owners.find(e=>e.myinfo.uinfin === loginUser.uinfin)?.structure_status ?? StructureStatusEnum.outgoing;
    return structure_status 
  },[applicationStep1FormData?.household, loginUser.uinfin]);
  
  const { data, isLoading } = useGetStageD1ObjQuery({ application_uuid: application_uuid!, uinfin: loginUser?.uinfin ?? "", stage:"D4", structure: loginUserStructureStatus , singpass_token: singpassToken ?? ""},{ skip: !application_uuid || !loginUserStructureStatus });
  

  useEffect(() => {
    applicationReviewSetFormValue(data);
  }, [data, application_uuid, applicationReviewSetFormValue]);


  const completeFinancialPlan = useCallback(async() => {
    //API CALLING TO UPDATE STATUS
    let submittingData = {
      application_uuid: application_uuid,
      stage: "E"
    }
    try{
      const response = await PolymerAxios("", singpassToken).post(API_ApplicationStageUpdate, submittingData);
      if(response.status === 200){
        navigate(`/application-coo?application_id=${application_uuid}`)
      }
    }catch(error){
      console.log("Error update polymer status ",error);
    }
  },[application_uuid, navigate, singpassToken]);

  const backNavigate = useCallback(() => {
    navigate(`/application-coo?application_id=${application_uuid}`)
  }, [application_uuid, navigate]);

  useEffect(() => {
    if (customWindow.wogaaCustom) {
      customWindow.wogaaCustom.startTransactionalService(stageDTrackingId)
      customWindow.wogaaCustom.completeTransactionalService(stageDTrackingId);
    }
  }, []);

  const solicitorMessageInfo = useMemo((): StageDMessageInfo[] | undefined => {
    return new StageDReviewApplication(data)?.solicitor_message_info?.filter( (e) => e.type === "SOLICITOR");
  }, [data]);

  //------Start of form handling function------//
  const messageType = useMemo((): StageDMessageType => {
    //The logic here is that HDB cannot act form will only show once when type for each message should be "SOLICITOR". Else will be "GENERIC"
    // return new StageDReviewApplication(data).message_info.some((item)=> item.type === "SOLICITOR") ? "SOLICITOR" : "GENERIC";
    return data?.message_type ?? "GENERIC";
  }, [data]);

  //----Start of solicitor section-------
  const messageInfoForCurrent = data?.solicitor_message_info?.find(item => item.owner_type === "CURRENT_OWNER" || item.owner_type === "OUTGOING_OWNER");
  const additionalFieldsForCurrent = useMemo(() => {
    return {
      ownerType: messageInfoForCurrent ? messageInfoForCurrent?.owner_type : "",
      solicitorType: messageInfoForCurrent?.solicitor_request_type
    }
  }, [messageInfoForCurrent?.uuid])
  const {
    values: currentSolicitorValues,
    formValid: initialCurrentSolicitorFormValid,
    errors: currentSolicitorErrors,
    setFormValue: setCurrentSolicitorFormValue,
  }: {
    handleChange: any;
    values: StageDSolicitorApplicationForm;
    errors: IErrors;
    formValid: boolean;
    setFormValue: (update: StageDSolicitorApplicationForm) => void;
  } = useForm(new StageDSolicitorApplicationForm(), () => {}, validateStageDSolicitor, additionalFieldsForCurrent);
  const currentSolicitorFormValid = initialCurrentSolicitorFormValid || !messageInfoForCurrent

  const messageInfoForProposed = data?.solicitor_message_info?.find(item => item.owner_type === "PROPOSED_OWNER");
  const additionalFieldsForProposed = useMemo(() => {
    return {
      ownerType: messageInfoForProposed ? "PROPOSED_OWNER" : "",
      solicitorType: messageInfoForProposed?.solicitor_request_type
    }
  }, [messageInfoForProposed?.uuid])
  const {
    values: proposedSolicitorValues,
    formValid: initialProposedSolicitorFormValid,
    errors: proposedSolicitorErrors,
    setFormValue: setProposedSolicitorFormValue,
  }: {
    handleChange: any;
    values: StageDSolicitorApplicationForm;
    errors: IErrors;
    formValid: boolean;
    setFormValue: (update: StageDSolicitorApplicationForm) => void;
  } = useForm(new StageDSolicitorApplicationForm(), () => {}, validateStageDSolicitor, additionalFieldsForProposed);
  const proposedSolicitorFormValid = initialProposedSolicitorFormValid || !messageInfoForProposed

  
  const setCurrentSolicitorFormValueHandler = useCallback((values:StageDSolicitorApplication[])=>{
    const clonedValues = cloneDeep(values)
    setCurrentSolicitorFormValue({
      solicitors: clonedValues
    });
  },[setCurrentSolicitorFormValue])

  const setProposedSolicitorFormValueHandler = useCallback((values:StageDSolicitorApplication[])=>{
    const clonedValues = cloneDeep(values)
    setProposedSolicitorFormValue({
      solicitors: clonedValues
    });
  },[setProposedSolicitorFormValue])

  const submitHDBCannotActForm = useCallback(async () => {
    if (currentSolicitorValues.solicitors.length !== 0) {
      let formDataForCurrent = currentSolicitorValues.solicitors.map(solicitorItem => {
        const currentOwnerMessageInfo = solicitorMessageInfo?.find((info) => info.owner_type === "CURRENT_OWNER" || info.owner_type === "OUTGOING_OWNER")
        const solicitor_obj = new StageDSolicitorUpdate();
        solicitor_obj.setApplicationUuid(application_uuid ?? null);
        solicitor_obj.setParentUuid(solicitorItem.uuid);
        solicitor_obj.setGroupUUid(solicitorItem.group_uuid);
        if(currentOwnerMessageInfo?.owner_type === "CURRENT_OWNER"){
          solicitor_obj.setCurrentSolicitor(solicitorItem, currentOwnerMessageInfo?.solicitor_request_type);
        }

        if(currentOwnerMessageInfo?.owner_type === "OUTGOING_OWNER"){
          solicitor_obj.setOutgoingSolicitor(solicitorItem, currentOwnerMessageInfo?.solicitor_request_type);
        }
        return solicitor_obj.json();
      })

      try {
        await PolymerAxios(loginUser?.uinfin ?? "", singpassToken).post(
          API_SolicitorUpdate,
          formDataForCurrent
        );
      } catch (error) {
        console.log("Error submitting hdb cannot act form", error);
      }
    }

    if (proposedSolicitorValues.solicitors.length !== 0) {
      let formDataForProposed = proposedSolicitorValues.solicitors.map(solicitorItem => {
        const proposedOwnerMessageInfo = solicitorMessageInfo?.find((info) => info.owner_type === "PROPOSED_OWNER")
        const solicitor_obj = new StageDSolicitorUpdate();
        solicitor_obj.setApplicationUuid(application_uuid ?? null);
        solicitor_obj.setParentUuid(solicitorItem.uuid);
        solicitor_obj.setGroupUUid(solicitorItem.group_uuid);
        solicitor_obj.setProposedSolicitor(solicitorItem, proposedOwnerMessageInfo?.solicitor_request_type);
        return solicitor_obj.json();
      })

      try {
        await PolymerAxios(loginUser?.uinfin ?? "", singpassToken).post(
          API_SolicitorUpdate,
          formDataForProposed
        );
      } catch (error) {
        console.log("Error submitting hdb cannot act form", error);
      }
    }

  }, [application_uuid, currentSolicitorValues, proposedSolicitorValues, loginUser?.uinfin, singpassToken]);
  //-------End of solicitor section--------

  const requestFolders = useMemo(() => {
    return data?.folders?.filter(item => item.is_request_document === true) ?? [];
  }, [data])

  useEffect(() => {
    if (requestFolders.length !== 0 || data?.message_info?.length !== 0 || data?.solicitor_message_info?.length !== 0) {
      let temp: string[] = [];
      //push messages, documents according to the order of sections
      if (data?.solicitor_message_info && data?.solicitor_message_info?.length > 0) {
        temp = temp.concat(Array(data?.solicitor_message_info?.length).fill("messages"));
      }

      //push messages, documents according to the order of sections
      if (data?.message_info && data?.message_info?.length > 0) {
        temp = temp.concat(Array(data?.message_info?.length).fill("messages"));
      }

      if (requestFolders && requestFolders?.length > 0) {
        const nonLawyerLetterDocs = requestFolders.filter(item => item.name !== "Letter of Lawyer's Representation");
        if(messageType === "GENERIC" || nonLawyerLetterDocs.length > 0){//remove lawyer letter from pending items count if has solicitor message as it will be validated together with solicitor message
          const documentsCount = messageType === "GENERIC" ? requestFolders.length : nonLawyerLetterDocs.length;
          temp = temp.concat(Array(documentsCount).fill("documents"));
        }
        //fill with repeating documents as it is needed for pending items count display
      }

      setPendingItems(temp);
    }
  }, [data, messageType, requestFolders]);

  const solicitorFolders = useMemo(() => {
    const lawyerLetterDocs = requestFolders.filter(item => item.name === "Letter of Lawyer's Representation");
    if(messageType === "GENERIC" || lawyerLetterDocs.length === 0){
        return [];
    }
    const clonedLawyerLetterDoc = cloneDeep(lawyerLetterDocs[0]);
    for(const comment of clonedLawyerLetterDoc.comments){//display hardcoded msg instead of comments from hdb
       comment.text = "A legal document stating that the solicitor or law firm is representing for the party in a case.";
    }
    if(clonedLawyerLetterDoc.comments.length > 0){
      clonedLawyerLetterDoc.comments = [clonedLawyerLetterDoc.comments[0]];
    }
    return [clonedLawyerLetterDoc];
  }, [messageType, requestFolders])

  const normalFolders = useMemo(() => {
      return messageType === "GENERIC" ? requestFolders : requestFolders.filter(item => item.name !== "Letter of Lawyer's Representation");
  }, [messageType, requestFolders])

  const submitApplicationUpdate = async () => {
    const submittingData = processSubmitApiData();
    const submittingItems: string[] = [];
    const messagesCount = applicationInPrincipleValue.message_info.filter(
      (item) => item?.reply && item?.reply.length > 0
    ).length;
    const filesCount = filesItemsStorage.length;
    if (messagesCount > 0) {
      submittingItems.push("messages");
    }

    if (filesCount > 0) {
      submittingItems.push("documents");
    }

    const updatedPendingItems = [...pendingItems].filter(
      (item) => !submittingItems.includes(item)
    );

    if (messageType === "SOLICITOR") {
      //if has HDB cannot act form, then run this.
      submitHDBCannotActForm();
    }
    try {
      await PolymerAxios(loginUser?.uinfin ?? "", singpassToken).post(
        API_ApplicationReply,
        submittingData
      );
      setPendingItems(updatedPendingItems);
      setFileItemsStorage([]);
      setIsSubmitted(true);
      window.location.reload();
    } catch (error) {
      console.log("Error submitting application update", error);
    }
  };

  useEffect(() => {
    applicationReviewSetFormValue(data);
  }, [data, application_uuid, applicationReviewSetFormValue]);
  const closeModal = useCallback(() => {
    setIsModalOpen(false);
  },[isModalOpen]);
  const handleModalTrigger = useCallback(() => {
    setIsModalOpen(true);
  },[isModalOpen]);
  const handlePrimaryButton = useCallback(() => {
    closeModal();
  },[isModalOpen]);
  const handleSecondaryButton = useCallback(async () => {
    // to navigate => when get destination
    await submitApplicationUpdate();
    closeModal();
  },[isModalOpen,submitApplicationUpdate]);

  const processSubmitApiData = useCallback(() => {
    const submittingMessages = [
      ...applicationInPrincipleValue.message_info.filter(item => item.type !== "SOLICITOR" && item.reply && item.reply.length > 0).map((item) => {
        return {
          due_date: item.due_date,
          received_date: item.received_date,
          subject: item.subject,
          message: item.reply,
          group_uuid: item.group_uuid, //Groupd uuid
          parent_uuid: item.uuid, //existing uuid will tie to parent_uuid
          uuid: uuidv4(), //Generate new uuid for to biome side (can be any unique value here)
          status: item.status,
          reply: item.reply
        };
      }),
    ];

    const clonedFolders = JSON.parse(
      JSON.stringify([...normalFolders])
    );
    for (const folder of clonedFolders) {
      for (const comment of folder.comments) {
        const files = filesItemsStorage.filter(
          (item) => item.label === folder.name && item.file_id !== ""
        );
        comment.documents = files.map(
          (item) =>
            new StageDDocumentsInfo({
              name: item.file_content.file_name ?? "",
              submitted_date: item.submitted_date ?? "",
              size: item?.file_content?.size ?? 0,
              uuid: item.file_id.toString(),
              key: item.key,
            })
        );
      }
    }

    const finalProcessedFolders = clonedFolders.filter((item: any) => item.comments.every((item: any) => item.documents.length !== 0));
    return {
      ...applicationInPrincipleValue,
      message_info: applicationInPrincipleValue.message_info.every(item => item?.reply && item?.reply?.length > 0) ? submittingMessages : [],
      folders: filesItemsStorage.length > 0 ? finalProcessedFolders : [],
    };
  }, [applicationInPrincipleValue, filesItemsStorage, normalFolders]);

  //-----Start of reply button validation------
  const isCurrentSolicitorFormPartial = useMemo(() => {
    const currentSolicitorMessage = (solicitorMessageInfo ?? []).find(item => item.owner_type === "CURRENT_OWNER" || item.owner_type === "OUTGOING_OWNER");
    if(messageType === "GENERIC" || !currentSolicitorMessage){
      return false;
    }
    if(currentSolicitorValues.solicitors.length === 0){
      return false;
    }
    const solicitor = currentSolicitorValues.solicitors[0];
    let checkingStringArray: string[] = [];
    const solicitorValuesArray = [
      solicitor.current.private_solicitor.name_of_firm, 
      solicitor.current.private_solicitor.email_of_solicitor, 
      solicitor.current.private_solicitor.uen,
    ];
    const conveyancingSolicitorValuesArray = [
      solicitor.current.conveyancing_private_solicitor.name_of_firm, 
      solicitor.current.conveyancing_private_solicitor.email_of_solicitor, 
      solicitor.current.conveyancing_private_solicitor.uen
    ]
    if(currentSolicitorMessage.solicitor_request_type === "BOTH"){
        checkingStringArray = solicitorValuesArray.concat(solicitor.current.private_solicitor.represented_same_solicitor ? solicitorValuesArray : conveyancingSolicitorValuesArray);
    }else if(currentSolicitorMessage.solicitor_request_type === "MORTGAGE"){
        checkingStringArray = solicitorValuesArray;
    }else{
        checkingStringArray = conveyancingSolicitorValuesArray;
    }

    return checkingStringArray.some(item => item && item.length > 0) && checkingStringArray.some(item => !item);

  }, [messageType, solicitorMessageInfo, currentSolicitorValues])

  const isProposedSolicitorFormPartial = useMemo(() => {
    const proposedSolicitorMessage = (solicitorMessageInfo ?? []).find(item => item.owner_type === "PROPOSED_OWNER");
    if(messageType === "GENERIC" || !proposedSolicitorMessage){
      return false;
    }
    if(proposedSolicitorValues.solicitors.length === 0){
      return false;
    }
    const solicitor = proposedSolicitorValues.solicitors[0];
    let checkingStringArray: string[] = [];
    const solicitorValuesArray = [
      solicitor.proposed.private_solicitor.name_of_firm, 
      solicitor.proposed.private_solicitor.email_of_solicitor, 
      solicitor.proposed.private_solicitor.uen,
    ];
    const conveyancingSolicitorValuesArray = [
      solicitor.proposed.conveyancing_private_solicitor.name_of_firm, 
      solicitor.proposed.conveyancing_private_solicitor.email_of_solicitor, 
      solicitor.proposed.conveyancing_private_solicitor.uen
    ]
    if(proposedSolicitorMessage.solicitor_request_type === "BOTH"){
        checkingStringArray = solicitorValuesArray.concat(solicitor.proposed.private_solicitor.represented_same_solicitor ? solicitorValuesArray : conveyancingSolicitorValuesArray);
    }else if(proposedSolicitorMessage.solicitor_request_type === "MORTGAGE"){
        checkingStringArray = solicitorValuesArray;
    }else{
        checkingStringArray = conveyancingSolicitorValuesArray;
    }

    return checkingStringArray.some(item => item && item.length > 0) && checkingStringArray.some(item => !item);

  }, [messageType, solicitorMessageInfo, proposedSolicitorValues])

  const isSolicitorFormValid = useMemo(():FieldValidationInterface => {
    if(messageType !== "SOLICITOR"){
      return {
        isValid: false,
        isPartial: false
      };
    }

    const requiredFileLabels = solicitorFolders.map(
      (item) => item.name
    );
    const uploadedFileLabels = filesItemsStorage
      .filter((item) => item.file_id !== "")
      .map((item) => item.label);

    const solicitorFoldersValid = requiredFileLabels.length === 0 || (requiredFileLabels.length > 0 && requiredFileLabels.every((item) =>
      uploadedFileLabels.includes(item)
    ));

    const valid = currentSolicitorFormValid && proposedSolicitorFormValid && solicitorFoldersValid;
    let partialBooleans: boolean[] = [];
    if(messageInfoForCurrent){
       partialBooleans.push(currentSolicitorFormValid);
       partialBooleans.push(solicitorFoldersValid)
    }

    if(messageInfoForProposed){
      partialBooleans.push(proposedSolicitorFormValid);
      partialBooleans.push(solicitorFoldersValid)
    }

    partialBooleans = uniq(partialBooleans);

    return { isValid: valid, isPartial: partialBooleans.length > 1 || isCurrentSolicitorFormPartial || isProposedSolicitorFormPartial};
  }, [messageType, currentSolicitorFormValid, proposedSolicitorFormValid, filesItemsStorage, isCurrentSolicitorFormPartial, isProposedSolicitorFormPartial, solicitorFolders, messageInfoForCurrent, messageInfoForProposed])

  const isMessagesValid = useMemo((): FieldValidationInterface => {
    let valid =
      applicationInPrincipleValue.message_info.length > 0 && applicationInPrincipleValue.message_info.every(
        (item) => item.is_saved && item.reply && item.reply.length > 0
      );
    const messageSaveStates = uniq(
      applicationInPrincipleValue.message_info.map((item) => item.is_saved ?? false)
    );

    const isPartial =
      (applicationInPrincipleValue.message_info.length > 0 && messageSaveStates.length !== 1) || //either includes save and non-saved state
      (applicationInPrincipleValue.message_info.some(
        //only non-saved states and is typing
        (item) => item.reply && item.reply.length > 0
      ) &&
        messageSaveStates.includes(false))
    const partial = valid === true ? false : isPartial;
    return { isValid: valid, isPartial: partial };
  }, [applicationInPrincipleValue]);

  const isDocumentsValid = useMemo((): FieldValidationInterface => {
    //Only filter the documents that is_request_document === true
    const requiredFileLabels = normalFolders.map(
      (item) => item.name
    );
    if(filesItemsStorage.some(item => item.file_id === "")) {
      return { isValid: false, isPartial: true };
    }
    const uploadedFileLabels = filesItemsStorage
      .filter((item) => item.file_id !== "")
      .map((item) => item.label);

    const valid = requiredFileLabels.length > 0 && requiredFileLabels.every((item) =>
      uploadedFileLabels.includes(item)
    );
    const onlySomeDocumentsUploaded = requiredFileLabels.some(item => uploadedFileLabels.includes(item)) && requiredFileLabels.some(item => !uploadedFileLabels.includes(item));
    const partial = valid === true ? false : onlySomeDocumentsUploaded;
    
    return { isValid: valid, isPartial: partial };
  }, [filesItemsStorage, normalFolders]);

  const isButtonEnabled = useMemo((): boolean => {
    if (isDocumentsValid.isPartial || isMessagesValid.isPartial || isSolicitorFormValid.isPartial) {
      return false;
    }

    if(applicationInPrincipleValue.message_info?.length > 0 && (solicitorMessageInfo ?? []).length > 0 && isMessagesValid.isValid !== isSolicitorFormValid.isValid){//require message and solicitor message to be submitted together
        return false;
    }

    return isDocumentsValid.isValid || isMessagesValid.isValid || isSolicitorFormValid.isValid;
  }, [isMessagesValid, isDocumentsValid, isSolicitorFormValid, applicationInPrincipleValue, solicitorMessageInfo]);

  //-----End of reply button validation------

  const ModalMessage = useMemo(() => {
    const messagesCount = pendingItems.includes("messages") ? (applicationInPrincipleValue.message_info.filter(
      (item) => item?.reply && item?.reply.length > 0
    ).length + (isSolicitorFormValid ? (solicitorMessageInfo?.length ?? 0) : 0)) : 0;
    const filesCount = pendingItems.includes("documents") ? filesItemsStorage.length : 0;

    return (
      <>
        <p style={{ marginBottom: "0.5rem" }}>
          HDB will receive your submission of the following:
        </p>
        <ul>
          {messagesCount > 0 && (
            <li style={{ marginBottom: "1rem" }}>
              {messagesCount} replied message{messagesCount > 1 ? "s" : ""}
            </li>
          )}
          {filesCount > 0 && (
            <li>
              {filesCount} submitted document{filesCount > 1 ? "s" : ""}
            </li>
          )}
        </ul>
      </>
    );
  }, [applicationInPrincipleValue, filesItemsStorage, pendingItems, isSolicitorFormValid, solicitorMessageInfo]);

  const submittingItemsCount = useMemo(() => {
    const totalMessageCount = applicationInPrincipleValue.message_info.filter(
      (item) => item?.reply && item?.reply.length > 0
    ).length + (isSolicitorFormValid.isValid ? (solicitorMessageInfo?.length ?? 0) : 0);

    let totalDocumentsCount = isDocumentsValid.isValid ? normalFolders.length : 0;
    if(isSolicitorFormValid.isValid){
       totalDocumentsCount += solicitorFolders.length;
    }

    const messagesCount = pendingItems.includes("messages") && totalMessageCount > 0 ? totalMessageCount : 0;

    const filesCount = pendingItems.includes("documents") && totalDocumentsCount > 0 && filesItemsStorage.length > 0 ? totalDocumentsCount : 0;

    return messagesCount + filesCount;
  }, [applicationInPrincipleValue, filesItemsStorage, pendingItems, isSolicitorFormValid, solicitorMessageInfo, normalFolders, solicitorFolders, isDocumentsValid]);

  useEffect(() => { 
    const needReply = applicationInPrincipleValue.message_info.length > 0 || (applicationInPrincipleValue.solicitor_message_info && applicationInPrincipleValue.solicitor_message_info.length > 0) || requestFolders.length > 0;
    setRequiredReply(needReply);
  }, [applicationInPrincipleValue, requestFolders]);
  
  const isEmpty = useMemo(():boolean=>{
    if(requestFolders.length === 0 && applicationInPrincipleValue.message_info.length === 0 && solicitorMessageInfo?.length === 0){
      return true;
    }
    return false;
  },[applicationInPrincipleValue, requestFolders, solicitorMessageInfo])

  const financialPlans = useMemo(() => {
    return data?.folders?.filter(item => item.name === "Financial Plan for Current Owners" || item.name === "Financial Plan for Proposed Owners") ?? [];
} , [data])

  return (
    <ApplicationCooLayout>
      <div className='polymer-application-coo__wrapper'>
        <TextSubheader
          subheaderMain="Stage D: Process Application"
          subheaderSub={startApplicationFormData.selected_hdb_property?.address}
          paddingLeftRight={42}
        />
        <Stepper
          activeStep={activeStep}
          items={stepperItemsStageD}
          style={{ margin: "62px auto" }}
        />
        <div className="d-flex justify-content-center">
          <SectionCard
            required={false}
            className="flex-fill"
            titleChildren={
              <>
                <StepperItem
                  variant="section_active"
                  size={40}
                  step={activeStep.toString()}
                  marginBottom={"0px"}
                />
                <P2TextDescription title={"Review Financial Plan"} />
              </>
            }
            contentChildren={
              <>
                {isLoading && <LottieLoader/>}
                {!isLoading &&
                  <>
                    {financialPlans.length > 0 && <DownloadFinancialPlan documents={financialPlans ?? []} />}
                    {financialPlans.length === 0 && <ReviewingPage message="HDB is processing your Financial Plans. We will let you know if there are any updates on the application."/>}
                    {requiredReply && (
                      <>
                        <div style={{ marginTop: 32, marginBottom: 24 }} />
                        <div className={`polymer_sectioncard__top`}>
                          <div
                            style={{
                              flex: 1,
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              gap: 10,
                            }}
                          >
                            <P2TextDescription title={"Updates on Application"} />
                          </div>
                        </div>
                        <div className="py-4">
                          <ApplicationUpdateForm
                              normalFolders={normalFolders}
                              solicitorFolders={solicitorFolders}
                              filesItemsStorage={filesItemsStorage}
                              setFileItemsStorage={setFileItemsStorage}
                              applicationReviewValues={applicationInPrincipleValue}
                              applicationReviewSetFormValue={
                                applicationReviewSetFormValue
                              }
                              pendingItems={pendingItems}
                              messageType={messageType}
                              solicitorMessageInfo={solicitorMessageInfo}
                              currentSolicitorFormValue={setCurrentSolicitorFormValueHandler}
                              currentSolicitorErrors={currentSolicitorErrors}
                              currentSolicitorValues={currentSolicitorValues.solicitors}
                              proposedSolicitorFormValue={setProposedSolicitorFormValueHandler}
                              proposedSolicitorErrors={proposedSolicitorErrors}
                              proposedSolicitorValues={proposedSolicitorValues.solicitors}
                            />
                        </div>
                      </>
                    )}
                  </>
                }
                {/* {isEmpty && !isLoading && <ReviewingPage message="HDB is processing your Financial Plans. We will let you know if there are any updates on the application."/>} */}
              </>
            }
          />
        </div>
      </div>
      
      <Separator style={{margin:"32px 42px"}}/>

      <div className='polymer-application-coo__card-button'>
        <P2ButtonGroup>
          <P2Button variant={"outline-primary"} onClick={backNavigate}>
            Back
          </P2Button>
          <P2Button variant="primary-1" disabled={!data?.hasLegalDocsReady} onClick={completeFinancialPlan}>
            Confirm financial plan
          </P2Button>
          {requiredReply && <P2Button variant="primary-1" disabled={!isButtonEnabled} onClick={handleModalTrigger}>
            Reply all
          </P2Button>}
        </P2ButtonGroup>
      </div>
      <P2Modal
        isOpen={isModalOpen}
        onCloseModal={closeModal}
        variant="default"
        title={`You are submitting: ${submittingItemsCount} action item${
          submittingItemsCount > 1 ? "s" : ""
        }`} // in future to change to .length
        primaryButtonText="No, continue editing"
        secondaryButtonText="Yes, submit to HDB"
        primaryButtonFunction={handlePrimaryButton}
        secondaryButtonFunction={handleSecondaryButton}
        children={ModalMessage}
      />
    </ApplicationCooLayout>
  );
}

export default StageDFinancialReview;
